<div class="title">
    <span>Download Report</span>
</div>
<div class="dialog-content">
    <div class="add-container">
        <app-widget-textbox [(model)]="fileName" title="File Name" placeholder="Type here..."
            textboxWidth="455px"></app-widget-textbox>
    </div>
    <br />
    <div class="select-container">
        <span>{{ 'dashboard:File Type' | i18next }}</span>
        <div>
            <ng-select [items]="fileTypes" bindLabel="label" bindValue="id" placeholder="{{ 'Select'| i18next }}"
                [(ngModel)]="fileType" [searchable]="false">
                <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index"
                    dropdownPosition="bottom">
                    <div class="ng-option-template">
                        {{item}}
                    </div>
                </ng-template>
            </ng-select>
            <div *ngIf="isChart" class="size-container">
                <app-widget-numberbox class="width-box" [isWidth]="true" [(model)]="imgWidth" title="Width"
                    (modelChange)="imgWidth=$event" placeholder="Type here..."
                    textboxWidth="200px"></app-widget-numberbox>
                <app-widget-numberbox class="height-box" [isWidth]="false" [(model)]="this.imgHeight" title="Height"
                    (modelChange)="imgHeight=$event" placeholder="Type here..."
                    textboxWidth="200px"></app-widget-numberbox>
            </div>
        </div>
        <div *ngIf="fileType==='XLSX' && showTotalRowOption()" class="xlsx-checkbox-container">
            <input type="checkbox" id="xlsx-cb" name="xlsx-cb" (change)="changeTotalCheckbox(isTotalChecked)" [(ngModel)]="isTotalChecked"/>
            <label for="xlsx-cb">Include total row</label>
        </div>
    </div>
</div>

<mat-dialog-actions>
    <button mat-flat-button [ngClass]="['secondary-button']" (click)="onCancel()">{{ 'Cancel' | i18next }}</button>
    <button mat-flat-button [ngClass]="['primary-button']" (click)="onDownload()">{{ 'Download' | i18next }}</button>
</mat-dialog-actions>
